import React from 'react';





interface RsProps {
    size?: number;
    color?: string;
}

const Rs: React.FC<RsProps> = ({ size = 22, color = '#3EB6AE' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 15 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9.3327 14.1741C9.06503 14.7405 8.8881 15.3553 8.82031 15.9999L14.4848 14.8507C14.7524 14.2844 14.9292 13.6695 14.9972 13.0249L9.3327 14.1741Z"
                fill={color}
            />
            <path
                d="M14.4876 11.4079C14.7553 10.8416 14.9322 10.2268 15 9.58212L10.5876 10.4778V8.75601L14.4875 7.96504C14.7551 7.39872 14.9321 6.78388 14.9999 6.13924L10.5874 7.03412V0.842159C9.91131 1.20447 9.31085 1.68674 8.82274 2.25561V7.39223L7.05806 7.75021V0C6.38195 0.362181 5.78149 0.844579 5.29338 1.41345V8.10806L1.34489 8.90883C1.07722 9.47515 0.900155 10.09 0.832236 10.7346L5.29338 9.82981V11.9981L0.512392 12.9677C0.24472 13.534 0.0677852 14.1489 0 14.7935L5.00436 13.7785C5.41174 13.6977 5.76187 13.4678 5.98951 13.1515L6.90728 11.8529V11.8526C7.00255 11.7183 7.05806 11.5563 7.05806 11.3818V9.47184L8.82274 9.11386V12.5574L14.4875 11.4077L14.4876 11.4079Z"
                fill={color}
            />
        </svg>
    );
};

export default Rs;
